module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alertBigImg"
  }, [_c('div', {
    staticClass: "imgMask",
    on: {
      "click": _vm.imgFun
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img_Pos",
    attrs: {
      "src": _vm.imgSrc
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-30dbd42d","hasScoped":false}!./~/.12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/question/alertBigImg.vue
// module id = 183
// module chunks = 1